import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { VIDEO_PATH } from "../env";
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";

const MainFrame = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    return (
        <section className="tm-hero">
            <video
                className="tm-hero__video"
                src={VIDEO_PATH}
                autoPlay
                loop
                muted
                playsInline
            />
            <div className="tm-hero__veil"/>
            <div className="tm-hero__content">
                <span className="tm-eyebrow tm-rise">
                    {de ? 'Deutschland · Portugal — seit 2001' : 'Alemanha · Portugal — desde 2001'}
                </span>
                <h1 className="tm-hero__title tm-rise-1">
                    {de
                        ? <span>Wir halten Ihnen den Rücken frei — <em>für Ihr Kerngeschäft.</em></span>
                        : <span>Nós tratamos da burocracia — <em>para que se concentre no essencial.</em></span>}
                </h1>
                <p className="tm-hero__lede tm-rise-2">
                    {de
                        ? 'Tomé & Martins Dienstleistungen ist Ihr Partner für Büroservice, Hilfestellungen und Verwaltung. Persönlich, zweisprachig und mit einem starken Netzwerk aus Steuerberatern und Fachanwälten in Deutschland und Portugal.'
                        : 'A Tomé & Martins Serviços é o seu parceiro para serviços de escritório, assistência e administração. Pessoal, bilingue e com uma forte rede de consultores fiscais e advogados na Alemanha e em Portugal.'}
                </p>
                <div className="tm-hero__actions tm-rise-3">
                    <Link to="/contact/" className="tm-btn tm-btn--primary">
                        <i className="fas fa-comments"/>
                        {de ? 'Erstgespräch vereinbaren' : 'Marcar primeira conversa'}
                    </Link>
                    <Link to="/services/" className="tm-btn tm-btn--ghost">
                        {de ? 'Leistungen entdecken' : 'Descobrir serviços'}
                        <i className="fas fa-arrow-right"/>
                    </Link>
                </div>
                <div className="tm-hero__facts tm-rise-3">
                    <div className="tm-hero__fact">
                        <strong>20+</strong>
                        <span>{de ? 'Jahre Erfahrung' : 'Anos de experiência'}</span>
                    </div>
                    <div className="tm-hero__fact">
                        <strong>2</strong>
                        <span>{de ? 'Länder, ein Team' : 'Países, uma equipa'}</span>
                    </div>
                    <div className="tm-hero__fact">
                        <strong>DE / PT</strong>
                        <span>{de ? 'Zweisprachige Betreuung' : 'Apoio bilingue'}</span>
                    </div>
                    <div className="tm-hero__fact">
                        <strong>1</strong>
                        <span>{de ? 'Ansprechpartner für alles' : 'Contacto para tudo'}</span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MainFrame;



// WEBPACK FOOTER //
// ./src/components/MainFrame.js